/**
 * Render a snapshot watermark (epoch seconds or ISO-8601) as a short
 * "Jun 30, 06:00"-style label, or null when absent/unparseable. Shared by the
 * traffic-origin panels and the never-authenticated tile + drawer so every
 * snapshot-backed surface labels freshness identically.
 */
export function formatSnapshotFreshness(raw?: string | null): string | null {
  if (!raw) return null;
  const epoch = Number(raw);
  const date = Number.isFinite(epoch) && epoch > 0 ? new Date(epoch * 1000) : new Date(pinNaiveIsoToUtc(raw));
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, {
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

// Backend snapshot watermarks are zone-less ISO strings in UTC; `new Date()` would
// read a zone-less string as local time. Append the UTC designator when (and only
// when) the string carries no zone, so the instant renders correctly in the viewer's
// timezone. Already-zoned strings ('Z' or ±hh:mm) and non-ISO inputs are untouched.
function pinNaiveIsoToUtc(raw: string): string {
  const t = raw.indexOf("T");
  if (t === -1) return raw;
  const time = raw.slice(t + 1);
  const hasZone = /[zZ]$/.test(time) || /[+-]\d{2}:?\d{2}$/.test(time);
  return hasZone ? raw : `${raw}Z`;
}
